import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      id: 1,
      icon: 'ri-star-line',
      title: 'Doğum Haritası Analizi',
      description: 'Doğum anınızdaki gezegen konumlarının size özel analizini yaparak, kişiliğinizi, potansiyelinizi ve yaşam yolunuzu keşfedin.',
      duration: '90 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Kendini tanımak isteyenler', 'Yaşam amacını arayanlar', 'Kişisel gelişim yolculuğunda olanlar'],
      image: 'https://public.readdy.ai/ai/img_res/fafae30412b86143ee55c2fabc290823.jpg',
    },
    {
      id: 2,
      icon: 'ri-heart-2-line',
      title: 'Sinastri / İlişki Uyumu',
      description: 'İki kişinin doğum haritalarını karşılaştırarak ilişki dinamiklerini, uyum alanlarını ve gelişim fırsatlarını analiz edin.',
      duration: '75 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Çiftler', 'İlişki sorunları yaşayanlar', 'Uyum arayan partnerler'],
      image: 'https://readdy.ai/api/search-image?query=two%20overlapping%20birth%20charts%20showing%20synastry%20compatibility%20analysis%20with%20connecting%20lines%20between%20planetary%20positions%20romantic%20cosmic%20background%20with%20navy%20blue%20and%20golden%20tones%20relationship%20astrology&width=800&height=600&seq=service102&orientation=landscape',
    },
    {
      id: 3,
      icon: 'ri-calendar-event-line',
      title: 'Yıllık Öngörü / Transit Analizi',
      description: 'Gelecek dönemde yaşayacağınız gezegen geçişlerini analiz ederek, fırsatları ve dikkat edilmesi gereken dönemleri öğrenin.',
      duration: '60 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Planlama yapanlar', 'Önemli kararlar alacaklar', 'Gelecek dönem hakkında bilgi isteyenler'],
      image: 'https://readdy.ai/api/search-image?query=planetary%20transit%20chart%20showing%20moving%20planets%20and%20their%20aspects%20over%20time%20with%20timeline%20visualization%20on%20deep%20navy%20background%20golden%20orbital%20paths%20future%20prediction%20astrology%20concept&width=800&height=600&seq=service103&orientation=landscape',
    },
    {
      id: 4,
      icon: 'ri-briefcase-line',
      title: 'Kariyer & Para Danışmanlığı',
      description: 'Astrolojik haritanızdan yola çıkarak kariyer potansiyelinizi, finansal eğilimlerinizi ve başarı alanlarınızı keşfedin.',
      duration: '60 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Kariyer değişimi düşünenler', 'İş kuracaklar', 'Finansal planlama yapanlar'],
      image: 'https://readdy.ai/api/search-image?query=professional%20career%20astrology%20chart%20with%20midheaven%20and%20second%20house%20emphasis%20showing%20career%20path%20and%20financial%20indicators%20elegant%20business%20style%20with%20navy%20blue%20and%20gold%20accents&width=800&height=600&seq=service104&orientation=landscape',
    },
    {
      id: 5,
      icon: 'ri-compass-3-line',
      title: 'Spiritüel Rehberlik Seansı',
      description: 'Ruhsal gelişim yolculuğunuzda rehberlik, içsel farkındalık artırma ve kişisel dönüşüm desteği alın.',
      duration: '60 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Spiritüel arayışta olanlar', 'İçsel huzur arayanlar', 'Kişisel dönüşüm isteyenler'],
      image: 'https://readdy.ai/api/search-image?query=serene%20spiritual%20guidance%20meditation%20scene%20with%20person%20in%20peaceful%20contemplation%20surrounded%20by%20soft%20golden%20ethereal%20light%20and%20cosmic%20energy%20on%20calm%20navy%20background%20spiritual%20counseling%20concept&width=800&height=600&seq=service105&orientation=landscape',
    },
    {
      id: 6,
      icon: 'ri-heart-pulse-line',
      title: 'Enerji Çalışmaları (Şifa)',
      description: 'Enerji dengeleme, çakra temizliği ve şifa seanslarıyla bedeninizin ve ruhunuzun uyumunu sağlayın.',
      duration: '45-60 dakika',
      format: 'Online (Zoom/Google Meet)',
      suitableFor: ['Enerji blokajı yaşayanlar', 'Fiziksel/duygusal dengesizlik hissedenler', 'Şifa arayanlar'],
      image: 'https://readdy.ai/api/search-image?query=healing%20energy%20flow%20with%20glowing%20chakra%20points%20on%20human%20silhouette%20surrounded%20by%20golden%20light%20waves%20and%20spiritual%20energy%20streams%20on%20deep%20navy%20background%20energy%20healing%20visualization&width=800&height=600&seq=service106&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-primary-dark to-primary-navy overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="inline-block px-6 py-2 bg-gold/20 rounded-full mb-6">
              <span className="text-gold text-sm font-medium uppercase tracking-wider">Hizmetler</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-7xl font-bold text-white mb-6">
              Danışmanlık Hizmetlerim
            </h1>
            <p className="text-xl text-text-light max-w-3xl mx-auto leading-relaxed">
              Size özel astrolojik danışmanlık, spiritüel rehberlik ve enerji şifa seansları
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {services.map((service, index) => (
              <motion.article
                key={service.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-3xl border border-gold/20 overflow-hidden hover:shadow-2xl hover:border-gold/40 transition-all duration-500"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <div className="w-full h-full">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/60 via-transparent to-transparent"></div>
                  
                  {/* Icon Badge */}
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-gold rounded-full flex items-center justify-center shadow-xl">
                    <i className={`${service.icon} text-2xl text-primary-dark`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <h3 className="font-serif text-3xl font-bold text-primary-dark mb-4">
                    {service.title}
                  </h3>

                  <p className="text-text-medium leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* Details */}
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center space-x-3 text-sm">
                      <i className="ri-time-line text-gold"></i>
                      <span className="text-text-medium"><strong>Süre:</strong> {service.duration}</span>
                    </div>
                    <div className="flex items-center space-x-3 text-sm">
                      <i className="ri-video-line text-gold"></i>
                      <span className="text-text-medium"><strong>Format:</strong> {service.format}</span>
                    </div>
                  </div>

                  {/* Suitable For */}
                  <div className="mb-6">
                    <h4 className="text-sm font-bold text-primary-dark mb-3">Kimler İçin Uygun:</h4>
                    <ul className="space-y-2">
                      {service.suitableFor.map((item, idx) => (
                        <li key={idx} className="flex items-start space-x-2 text-sm text-text-medium">
                          <i className="ri-check-line text-gold mt-0.5"></i>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* CTA Button */}
                  <Link
                    to="/randevu"
                    className="block w-full py-3 bg-gold text-primary-dark text-center font-semibold rounded-full hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Randevu Al
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-cream">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Seans Akışı
            </h2>
            <p className="text-text-medium text-lg">
              Her seans özenle planlanır ve kişiye özel yürütülür
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: '1', title: 'Ön Görüşme', desc: 'İhtiyaçlarınızı belirleriz' },
              { step: '2', title: 'Hazırlık', desc: 'Haritanızı/enerjinizi analiz ederiz' },
              { step: '3', title: 'Seans', desc: 'Detaylı danışmanlık/şifa seansı' },
              { step: '4', title: 'Takip', desc: 'Süreç sonrası destek' },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-2xl p-6 text-center shadow-lg"
              >
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-gold font-bold text-xl">{item.step}</span>
                </div>
                <h4 className="font-serif text-lg font-bold text-primary-dark mb-2">
                  {item.title}
                </h4>
                <p className="text-sm text-text-medium">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-dark">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-6">
              Hangi Hizmeti Seçeceğinizden Emin Değil misiniz?
            </h2>
            <p className="text-text-light text-lg mb-8">
              Ücretsiz ön görüşmede size en uygun hizmeti birlikte belirleyelim
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link
                to="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Ücretsiz Ön Görüşme
              </Link>
              <a
                href="https://wa.me/905555555555"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="px-8 py-4 border-2 border-gold text-gold font-semibold rounded-full hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                WhatsApp ile Sor
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;